import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { validateLicense, isOfflineModeValid, shouldCheckServer } from '../utils/licenseHelper';

const LoadingContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    background: var(--bg-color);
    color: var(--primary-color);
`;

const LicenseCheck = ({ children }) => {
    const [isValid, setIsValid] = useState(null);
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        checkLicense();
        
        // Her 10 dakikada bir kontrol et (gereksiz istekleri azaltmak için)
        const interval = setInterval(checkLicense, 600000); // 10 dakika
        return () => clearInterval(interval);
    }, [location.pathname]);

    const checkLicense = async () => {
        const savedLicense = localStorage.getItem('site_license');
        
        if (!savedLicense) {
            redirectToActivation();
            return;
        }

        try {
            const licenseData = JSON.parse(savedLicense);
            const currentDomain = window.location.hostname;
            
            // Domain kontrolü
            if (licenseData.domain !== currentDomain) {
                localStorage.removeItem('site_license');
                redirectToActivation();
                return;
            }

            // Önce localStorage'dan kontrol et - eğer son 6 saat içinde doğrulandıysa direkt geç
            if (licenseData.last_validation && !shouldCheckServer(licenseData.last_validation)) {
                // Cache geçerli, sunucu kontrolüne gerek yok
                setIsValid(true);
                return;
            }

            // Cache eski veya yok - sunucuya kontrol et
            const isValid = await validateLicense(licenseData.key, currentDomain);
            
            if (!isValid) {
                // Sunucu kontrolü başarısız - ama cache hala geçerliyse (6 saat içinde) kullan
                if (licenseData.last_validation && isOfflineModeValid(licenseData.last_validation)) {
                    setIsValid(true);
                    return;
                }
                
                // Cache de geçersiz - aktivasyon sayfasına yönlendir
                localStorage.removeItem('site_license');
                redirectToActivation();
                return;
            }

            // Başarılı doğrulama - cache'i güncelle
            licenseData.last_validation = new Date().toISOString();
            localStorage.setItem('site_license', JSON.stringify(licenseData));

            setIsValid(true);
            
        } catch (error) {
            // Network hatası durumunda offline mod kontrolü (6 saatlik cache)
            const savedLicense = localStorage.getItem('site_license');
            if (savedLicense) {
                try {
                    const licenseData = JSON.parse(savedLicense);
                    // Son 6 saat içinde başarılı doğrulama varsa offline mod kullan
                    if (licenseData.last_validation && isOfflineModeValid(licenseData.last_validation)) {
                        // Offline mod geçerli (sadece network hatası durumunda)
                        setIsValid(true);
                        return;
                    }
                } catch (e) {
                    // Parse hatası, devam et
                }
            }
            
            // Network hatası ve geçersiz cache - aktivasyon sayfasına yönlendir
            localStorage.removeItem('site_license');
            redirectToActivation();
        }
    };

    const redirectToActivation = () => {
        setIsValid(false);
        if (!location.pathname.includes('/activate')) {
            navigate('/activate');
        }
    };

    if (isValid === null) {
        return (
            <LoadingContainer>
                <div>License kontrol ediliyor...</div>
            </LoadingContainer>
        );
    }

    if (!isValid && !location.pathname.includes('/activate')) {
        return null;
    }

    return children;
};

export default LicenseCheck;
